import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, unref as _unref, Fragment as _Fragment } from "vue"
import _imports_0 from '../../../assets/img/preview.png'
import _imports_1 from '../../../assets/img/preview3.png'
import _imports_2 from '../../../assets/img/preview4.png'
import _imports_3 from '../../../assets/img/dianhua.png'
import _imports_4 from '../../../assets/img/yinyue.png'
import _imports_5 from '../../../assets/img/yunjiniantang.png'
import _imports_6 from '../../../assets/img/share.png'
import _imports_7 from '../../../assets/img/look.png'
import _imports_8 from '../../../assets/img/nodata.png'


const _hoisted_1 = {
  class: "flex-n fac fjc",
  style: {"height":"100%"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "container-inside" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "top" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "title" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "name" }
const _hoisted_10 = {
  key: 0,
  class: "list"
}
const _hoisted_11 = { class: "card-content" }
const _hoisted_12 = { class: "card-top flex-n fjb" }
const _hoisted_13 = { class: "text flex-1" }
const _hoisted_14 = { class: "card-bottom flex-n" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "right flex-1" }
const _hoisted_17 = { class: "star" }
const _hoisted_18 = { class: "address flex-n" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "btn-area" }
const _hoisted_21 = { class: "submitcontent flex-n fac" }
const _hoisted_22 = { class: "flex-n flex-1" }
const _hoisted_23 = { class: "btn1" }
const _hoisted_24 = { class: "btn1" }
const _hoisted_25 = ["href"]
const _hoisted_26 = {
  key: 1,
  class: "nodata"
}
const _hoisted_27 = { class: "text2" }

import {onMounted, ref,nextTick,computed} from "vue";
import MessageDetail from "@/components/MessageDetail/MessageDetail.vue";
import StarScore from "@/components/StarScore/StarScore.vue";
import wx from "weixin-js-sdk";
import weChatObituaryApi from "@/utils/Api/WeChatObituary";
import commMethods from "@/assets/ts/common";
import {useRoute, useRouter} from "vue-router";
import {showToast} from 'vant';

export default /*@__PURE__*/_defineComponent({
  __name: 'previews',
  setup(__props) {

const route=useRoute();
const router=useRouter();
const state=ref(true);
const form=ref({})
const loading=ref(false);
onMounted(()=>{
  document.title='讣告预览'
  // document.title='内容失效'
  //分享
  commMethods.getTicket(['updateAppMessageShareData','updateTimelineShareData','hideMenuItems'])
  getDetail();
  getMessage();
  getObituaryMerchant();
  getView();
  obituaryShare();


})
const obituaryShare=()=>{
  weChatObituaryApi.share(route.query.id).then(res=>{
    console.log(res)
  })
}


const getDetail=()=> {
  loading.value = true;
  weChatObituaryApi.detail(route.query.id).then(res => {
    form.value=res.data;
    if(!res.data.obituaryBaseInfo.isrelease) {
      wx.ready(()=>{
        wx.hideMenuItems({
          menuList: ['menuItem:share:appMessage',"menuItem:share:timeline","menuItem:share:qq","menuItem:share:QZone"]
        })
      })

    }
    wx.ready(()=>{

      wx.updateAppMessageShareData({
        title: form.value.obituaryBaseInfo?.obituaryTitle, // 分享标题
        desc: '', // 分享描述
        // link: 'http://192.168.3.6:81?id='+route.query.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致

        link: 'https://mobile.dqhmbz.com/previews?id='+route.query.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl:form.value.deathinfo?.deathimg, // 分享图标
        success: function () {
          // 设置成功
          console.log(111)
          // showToast({
          //   message:'分享成功'
          // });
        },
        fail:(err)=>{
          // showToast({
          //   message:err
          // });
        }
      })

      wx.updateTimelineShareData({
        title: form.value.obituaryBaseInfo?.obituaryTitle, // 分享标题
        // link: 'http://192.168.3.6:81?id='+route.query.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致

        link: 'https://mobile.dqhmbz.com/previews?id='+route.query.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl:form.value.deathinfo?.deathimg, // 分享图标
        success: function () {
          // 设置成功
        }
      })
    })
    getMusic();
  }).finally(()=>{
    loading.value = false;
  })
}
let viewData=ref({
  shareTotal:0,
  viewTotal:0
});
const getView=()=> {
  weChatObituaryApi.view(route.query.id).then(res => {
    viewData.value=res.data;
  })
}

const audio=ref();
const getMusic=()=>{
  weChatObituaryApi.getBackgroundMusic(form.value.obituaryBaseInfo.backgroupmusicid).then(res=>{
    console.log(res)
    nextTick(()=> {
      audio.value.src=res.data?.musicpath
      playMusic();
    })
  })
}
//播放音乐
const isPlay=ref(false)
const playMusic=()=> {
  isPlay.value=!isPlay.value;
  console.log(document.getElementById('audio1').paused)

    if(isPlay.value){
      // document.getElementById('audio1').pause();
      document.getElementById('audio1').currentTime = 0;
      document.getElementById('audio1').play();
      console.log(document.getElementById('audio1').paused)
    } else{
      document.getElementById('audio1').pause();
    }


}
const messageList=ref([])
const getMessage=()=> {
  weChatObituaryApi.getObituaryMessgeList(route.query.id).then(res=>{
    console.log(res)
    messageList.value=res.data||[];
  })
}
const companyInfo=ref({})
//商家信息
const getObituaryMerchant=()=> {
  weChatObituaryApi.getObituaryMerchant(route.query.id).then(res => {
    console.log(222,res.data)
    companyInfo.value=res.data||{};
  })
}

const gotoPage=()=> {
  router.push('/memorialhall?id='+route.query.id)

}
const goPageDetail=(id:string)=> {
  router.push('/organizationdetail?id='+id)

}
const toShare=()=>{
  // weChatObituaryApi.share(route.query.id).then(res=>{
  //   console.log('分享')
  // })


}
const htmlContent=computed(()=>{
  return form.value.obituaryBaseInfo?.obituarycontent
})

return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("audio", {
      id: "audio1",
      ref_key: "audio",
      ref: audio,
      loop: ""
    }, _cache[3] || (_cache[3] = [
      _createElementVNode("source", null, null, -1)
    ]), 512),
    _createVNode(_component_van_overlay, {
      show: loading.value,
      "z-index": "400"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_van_loading, { color: "#1989fa" })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    (!loading.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (form.value.obituaryBaseInfo?.isrelease)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[7] || (_cache[7] = _createElementVNode("img", {
                      src: _imports_0,
                      class: "right-bg"
                    }, null, -1)),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("img", {
                          class: "img",
                          mode: "widthFix",
                          src: form.value.deathinfo?.deathimg
                        }, null, 8, _hoisted_6),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(form.value.obituaryBaseInfo?.obituaryTitle), 1),
                        _createElementVNode("div", {
                          class: "detail",
                          innerHTML: htmlContent.value
                        }, null, 8, _hoisted_8),
                        _createElementVNode("div", _hoisted_9, [
                          _createTextVNode(" 发告人：" + _toDisplayString(form.value.obituaryBaseInfo?.obituarySignature) + " ", 1),
                          _cache[4] || (_cache[4] = _createElementVNode("img", { src: _imports_1 }, null, -1))
                        ])
                      ]),
                      (messageList.value.length>0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode(MessageDetail, { "data-list": messageList.value }, null, 8, ["data-list"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: "card",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (goPageDetail(companyInfo.value.id)))
                      }, [
                        _cache[6] || (_cache[6] = _createElementVNode("img", {
                          class: "bg",
                          src: _imports_2
                        }, null, -1)),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, _toDisplayString(companyInfo.value?.companyName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("img", {
                              class: "img",
                              src: companyInfo.value?.merchantCover
                            }, null, 8, _hoisted_15),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", {
                                class: _normalizeClass(companyInfo.value?.merchantStatus?'name':'name2')
                              }, _toDisplayString(companyInfo.value?.merchantStatus?'协会会员单位':'非协会会员单位'), 3),
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(StarScore, {
                                  score: companyInfo.value?.serviceScore
                                }, null, 8, ["score"])
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", null, _toDisplayString(companyInfo.value?.companyAdddress), 1),
                                _createElementVNode("a", {
                                  href: 'tel:'+companyInfo.value.contactPhone,
                                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                                }, _cache[5] || (_cache[5] = [
                                  _createElementVNode("img", {
                                    class: "tel",
                                    src: _imports_3
                                  }, null, -1)
                                ]), 8, _hoisted_19)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("img", {
                        src: _imports_4,
                        class: _normalizeClass(isPlay.value?'playmusic':'stopmusic'),
                        onClick: playMusic
                      }, null, 2),
                      _createElementVNode("img", {
                        src: _imports_5,
                        onClick: gotoPage
                      })
                    ])
                  ])
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("div", { style: {"height":"6rem"} }, null, -1)),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[8] || (_cache[8] = _createElementVNode("img", { src: _imports_6 }, null, -1)),
                      _createElementVNode("div", null, _toDisplayString(_unref(viewData).shareTotal), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _cache[9] || (_cache[9] = _createElementVNode("img", { src: _imports_7 }, null, -1)),
                      _createElementVNode("div", null, _toDisplayString(_unref(viewData).viewTotal), 1)
                    ])
                  ]),
                  _createElementVNode("a", {
                    class: "btn2",
                    href: 'tel:'+form.value.obituaryfamilymember?.telphone
                  }, " 电话慰问 ", 8, _hoisted_25),
                  _createElementVNode("div", {
                    class: "btn3",
                    onClick: gotoPage
                  }, " 祝福留言 ")
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _cache[11] || (_cache[11] = _createElementVNode("img", { src: _imports_8 }, null, -1)),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text" }, "该内容已失效", -1)),
                _createElementVNode("button", {
                  class: "colorful-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/')))
                }, "返回首页"),
                _createElementVNode("div", _hoisted_27, _toDisplayString(companyInfo.value.companyName) + "为您提供全程服务", 1)
              ]))
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})